import Vue from 'vue'
import Router from 'vue-router'
const index = () =>
	import('@/pages/index')
const moduleIndex = () =>
	import('@/pages/moduleIndex')
// //登录页面
const login = () =>
	import('@/pages/login')
// 连锁园管理
const chainParkManagement = () =>
	import('@/pages/modules/chainParkManagement')

// 园所管理
// 园所管理-index
const gardenInfo = () =>
	import('@/pages/modules/gardenManagement/gardenInfo')
// 消息中心-messageCenter
const messageCenter = () =>
	import('@/pages/modules/messageCenter')
// 园所管理-校历
// const schoolCalendar = () =>
//   import ('@/pages/modules/gardenManagement/schoolCalendar')

const schoolCalendar = () =>
	import('@/pages/modules/gardenManagement/schoolCalendar')
const studentCalendar = () =>
	import('@/pages/modules/gardenManagement/studentCalendar')
const staffCalendar = () =>
	import('@/pages/modules/gardenManagement/staffCalendar')

// 园所管理-班级设置
const classSetting = () =>
	import('@/pages/modules/gardenManagement/classSetting')

// 职工管理
// 职工管理-列表首页
const staffIndexList = () =>
	import('@/pages/modules/staffManagement/staffIndexList')
// 职工管理-职工信息详情
const staffInfoDetails = () =>
	import('@/pages/modules/staffManagement/staffInfoDetails')
// 职工管理-职工添加
const staffAdd = () =>
	import('@/pages/modules/staffManagement/staffAdd')

// 学生管理
// 学生管理-学生管理列表
const studentManagementList = () =>
	import('@/pages/modules/studentManagement/studentManagementList')
// 学生管理-学生详情
const studentDetails = () =>
	import('@/pages/modules/studentManagement/studentDetails')
// 学生管理-Sunshine Report
const sunshineReport = () =>
	import('@/pages/modules/studentManagement/sunshineReport')

// 家长管理
// 家长管理-家长管理列表
const parentsManagementList = () =>
	import('@/pages/modules/parentsManagement/parentsManagementList')
// 家长管理-家长详情
const parentsDetails = () =>
	import('@/pages/modules/parentsManagement/parentsDetails')

// 报名招生
// 报名招生-招生管理
// 报名招生-分班统计
const divisionStatistics = () =>
	import('@/pages/modules/enrollAndRecruit/divisionStatistics')
// 报名招生-报名表管理
const enrollFormManagement = () =>
	import('@/pages/modules/enrollAndRecruit/enrollFormManagement')
//报名招生-面试题目管理
const interviewQuestions = () =>
	import('@/pages/modules/enrollAndRecruit/interviewQuestions')
//报名招生-汇总页面
const enrollmentManagement = () =>
	import('@/pages/modules/enrollAndRecruit/enrollmentManagement')
//报名招生-汇总详情页面
const enrollmentDetails = () =>
	import('@/pages/modules/enrollAndRecruit/enrollmentDetails')
//报名招生-报名渠道管理
const channelManagement = () =>
	import('@/pages/modules/enrollAndRecruit/channelManagement')
//报名招生-园所报名渠道管理
const channelGardenManagement = () =>
	import('@/pages/modules/enrollAndRecruit/channelGardenManagement')
//报名招生-招生数据漏斗
const enrollmentDataFunnel = () =>
	import('@/pages/modules/enrollAndRecruit/enrollmentDataFunnel')

// 通知管理
const newNotification = () =>
	import('@/pages/modules/notificationManagement/newNotification')
// 通知管理-通知列表展示
const notificationList = () =>
	import('@/pages/modules/notificationManagement/notificationList')
// 通知管理-通知详情
const notificationDetails = () =>
	import('@/pages/modules/notificationManagement/notificationDetails')
// 通知管理-学生请假列表
const studentLeaveList = () =>
	import('@/pages/modules/notificationManagement/studentLeaveList')
// 通知管理-新建请假
const studentLeaveNew = () =>
	import('@/pages/modules/notificationManagement/studentLeaveNew')
// 通知管理-请假详情
const studentLeaveDetails = () =>
	import('@/pages/modules/notificationManagement/studentLeaveDetails')
// 通知管理-便条
const chiefMailbox = () =>
	import('@/pages/modules/notificationManagement/chiefMailbox')
// 通知管理-意见反馈
const suggest = () =>
	import('@/pages/modules/notificationManagement/suggest')

// 日报管理
//新增需求
//活动模版
const activeTemplate = () =>
	import('@/pages/modules/dailyManagement/activeTemplate')

// 日报管理-日报上传 
const dailyUpload = () =>
	import('@/pages/modules/dailyManagement/dailyUpload')
const dailyUploadSingle = () =>
	import('@/pages/modules/dailyManagement/dailyUploadSingle')
const dailyUploadMultiple = () =>
	import('@/pages/modules/dailyManagement/dailyUploadMultiple')
// 日报管理-日报查询
const dailyQuery = () =>
	import('@/pages/modules/dailyManagement/dailyQuery')
// 日报管理-日报详情
const dailyDetails = () =>
	import('@/pages/modules/dailyManagement/dailyDetails')
	// 日报管理-日报详情
const dailyRead = () =>
import('@/pages/modules/dailyManagement/dailyRead')

// 午睡
const siestaIndex = () =>
	import('@/pages/modules/siesta/index')

//缴费管理
//缴费管理-收费项目设置
const chargeSetting = () =>
	import('@/pages/modules/paymentManagement/chargeSetting')
//缴费管理-收费记录
const chargeRecord = () =>
	import('@/pages/modules/paymentManagement/chargeRecord')
//缴费管理-园所收费项目
const headquartersCharges = () =>
	import('@/pages/modules/paymentManagement/headquartersCharges')
//缴费管理-学生优惠管理
const studentPrivilegeManagement = () =>
	import('@/pages/modules/paymentManagement/studentPrivilegeManagement')
//缴费管理-收费账单管理
const chargeBillManagement = () =>
	import('@/pages/modules/paymentManagement/chargeBillManagement/chargeBillManagement')
//缴费管理-退款账单管理
const refundBillManagement = () =>
	import('@/pages/modules/paymentManagement/refundBillManagement/refundBillManagement')
//缴费管理-当面付二维码
const payQRCode = () =>
	import('@/pages/modules/paymentManagement/payQRCode')
//缴费管理-账单统计
const billCensus = () =>
	import('@/pages/modules/paymentManagement/billCensus')
//缴费管理-学生收费统计
const studentsChargeCensus = () =>
	import('@/pages/modules/paymentManagement/studentsChargeCensus')


//考勤管理
//考勤看板
const attendanceIndex = () =>
	import('@/pages/modules/attendanceManagement/attendanceIndex')
//考勤配置
const attendanceConfiguration = () =>
	import('@/pages/modules/attendanceManagement/attendanceConfiguration')
//学生每日统计
const studentDailyStatistics = () =>
	import('@/pages/modules/attendanceManagement/studentDailyStatistics')
//职工每日统计
const staffDailyStatistics = () =>
	import('@/pages/modules/attendanceManagement/staffDailyStatistics')
//原始记录 
const originalCatalog = () =>
	import('@/pages/modules/attendanceManagement/originalCatalog')
//应用管理 
//const applicationManagement = () =>
//import ('@/pages/modules/attendanceManagement/applicationManagement')
////设备管理 
//const deviceManagement = () =>
//import ('@/pages/modules/attendanceManagement/deviceManagement')
//人员管理 
const personalManagement = () =>
	import('@/pages/modules/attendanceManagement/personalManagement')
const personalManagementEdit = () =>
	import('@/pages/modules/attendanceManagement/personalManagementEdit')
const personalManagementAuth = () =>
	import('@/pages/modules/attendanceManagement/personalManagementAuth')

// 视频监控
const videoMonitoring = () =>
	import('@/pages/modules/videoMonitoring/videoMonitoring')
//视频监控 - 管理视频	
const managementVideo = () =>
	import('@/pages/modules/videoMonitoring/managementVideo')

//官网新闻更新 - 公司动态
const companyDynamic = () =>
	import('@/pages/modules/websiteNewsUpdate/companyDynamic')
//官网新闻更新 - 园所动态	
const gardenDynamic = () =>
	import('@/pages/modules/websiteNewsUpdate/gardenDynamic')


// 幼儿食谱
// 幼儿食谱- 菜品定义
const dishes = () =>
	import('@/pages/modules/recipe/dishes')
// 幼儿食谱- 每周食谱
const dailyMeal = () =>
	import('@/pages/modules/recipe/dailyMeal')

// 菜单管理- 食谱定义
const recipesDefine = () =>
	import('@/pages/modules/menuManagement/recipesDefine')
// 菜单管理- 新建食谱
const recipesNew = () =>
	import('@/pages/modules/menuManagement/recipesNew')
// 菜单管理- 食谱详情
const recipesDetails = () =>
	import('@/pages/modules/menuManagement/recipesDetails')
// 菜单管理- 菜单定义index
const menuDefine = () =>
	import('@/pages/modules/menuManagement/menuDefine')
// 菜单管理- 新建周套餐
const newWeeklySetMeal = () =>
	import('@/pages/modules/menuManagement/newWeeklySetMeal')
// 菜单管理- 新建日套餐
const newDailyroutine = () =>
	import('@/pages/modules/menuManagement/newDailyroutine')
// 菜单管理- 周套餐详情
const WeeklySetMealDetails = () =>
	import('@/pages/modules/menuManagement/WeeklySetMealDetails')
// 菜单管理- 周套餐详情
const dailyroutineDetails = () =>
	import('@/pages/modules/menuManagement/dailyroutineDetails')
// 菜单管理- 班级菜单配置
const classMunuConfig = () =>
	import('@/pages/modules/menuManagement/classMunuConfig')
// 菜单管理- 班级每日菜单
const classDailyMenu = () =>
	import('@/pages/modules/menuManagement/classDailyMenu')
// 菜单管理- 配餐统计
const foodDistributionStatistics = () =>
	import('@/pages/modules/menuManagement/foodDistributionStatistics')

// 课程管理 
// 课程管理 -  总部课程管理
const headquartersCourseManagement = () =>
	import('@/pages/modules/courseManagement/headquartersCourseManagement')
// 课程管理 -  园所课程管理
const gardenCourseManagement = () =>
	import('@/pages/modules/courseManagement/gardenCourseManagement')
// 课程管理 -  班级课程
const classCourse = () =>
	import('@/pages/modules/courseManagement/classCourse')
// 课程管理 -  班级课程
const checkCourseDetails = () =>
	import('@/pages/modules/courseManagement/checkCourseDetails')

// 共享文档(QA) - 菜单管理
const menuManagement = () =>
	import('@/pages/modules/QA/menuManagement')
// 共享文档(QA) - 文件管理
const fileManagement = () =>
	import('@/pages/modules/QA/fileManagement')
// 共享文档(QA) - 分享文件
const shareFileList = () =>
	import('@/pages/modules/QA/shareFileList')
// 共享文档(QA) - 文档详情
const checkFile = () =>
	import('@/pages/modules/QA/checkFile')
// 凯斯教育课程家长
const eduParentsList = () =>
	import('@/pages/modules/QA/eduParentsList')
// 凯斯教育课程教师
const eduSchoolList = () =>
	import('@/pages/modules/QA/eduSchoolList')
const eduContent = () =>
	import('@/pages/modules/QA/eduContent')
//  培训地图
const eduMap = () =>
	import('@/pages/modules/QA/eduMap')
//  培训地图
const eduSecondMap = () =>
	import('@/pages/modules/QA/eduSecondMap')
//  培训地图课程列表
const eduMapCourseList = () =>
	import('@/pages/modules/QA/eduMapCourseList')
	//  培训地图课程列表
//  园所培训地图
const eduGardenMap = () =>
	import('@/pages/modules/QA/eduGardenMap')
//  园所培训地图职工授权
const eduMapEmployee = () =>
	import('@/pages/modules/QA/eduMapEmployee')
	
	

// 权限管理- 用户
const authorityManagementUser = () =>
	import('@/pages/modules/authorityManagement/user')
// 权限管理- 角色
const authorityManagementRole = () =>
	import('@/pages/modules/authorityManagement/role')

// 字典设置
const dictionaries = () =>
	import('@/pages/modules/dictionaries/dictionaries')

// 日志管理
const Journal = () =>
	import('@/pages/modules/Journal/Journal')

// 系统设置

const systemSet = () =>
	import('@/pages/modules/systemSet/systemSet')
// 系统设置首页
const systemSetIndex = () =>
	import('@/pages/modules/systemSet/index')
// 密码修改
const passwordSet = () =>
	import('@/pages/modules/systemSet/passwordSet')
//基本信息
const information = () =>
	import('@/pages/modules/systemSet/information')

// 404
const notFind = () =>
	import('@/pages/notFind');

Vue.use(Router)
let routes = [
	{
		path: '/',
		name: '',
		redirect: '/moduleIndex/systemSet/information'
	},
	{
		path: '/login',
		name: 'login',
		component: login,
		meta: {
			title: 'login'
		}
	},
	{
		path: '/index',
		name: 'index',
		component: index,
		redirect: '/moduleIndex/chainParkManagement',
		meta: {
			title: 'chainParkManagement'
		}
	},
	{
		path: '/moduleIndex',
		name: 'moduleIndex',
		component: moduleIndex,
		redirect: '/moduleIndex/chainParkManagement',
		meta: {
			title: 'chainParkManagement'
		},
		children: [{
			// 连锁园管理
			path: 'chainParkManagement', // 相对路径
			name: 'chainParkManagement',
			component: chainParkManagement,
			meta: {
				title: 'chainParkManagement'
			}
		},
		{
			// 消息中心
			path: '/moduleIndex/messageCenter',
			name: 'messageCenter',
			component: messageCenter,
			meta: {
				title: 'messageCenter'
			}
		},
		{
			// 园所管理-园所信息
			path: '/moduleIndex/gardenManagement/gardenInfo', // 绝对路径
			name: 'gardenInfo',
			component: gardenInfo,
			meta: {
				title: 'gardenInfo'
			}
		},

		{
			// 园所管理-校历
			path: '/moduleIndex/gardenManagement/schoolCalendar',
			name: 'schoolCalendar',
			component: schoolCalendar,
			meta: {
				title: 'schoolCalendar'
			},
			children: [{
				// 连锁园管理
				path: '/', // 相对路径
				redirect: 'studentCalendar',
			},

			{
				// 连锁园管理
				path: 'studentCalendar', // 相对路径
				name: 'studentCalendar',
				component: studentCalendar,
				meta: {
					title: 'studentCalendar'
				}
			},
			{
				// 连锁园管理
				path: 'staffCalendar', // 相对路径
				name: 'staffCalendar',
				component: staffCalendar,
				meta: {
					title: 'staffCalendar'
				}
			}
			],

		},
		{
			// 园所管理-班级设置
			path: '/moduleIndex/gardenManagement/classSetting',
			name: 'classSetting',
			component: classSetting,
			meta: {
				title: 'classSetting'
			}
		},
		{
			// 职工管理-列表首页
			path: '/moduleIndex/staffManagement/staffIndexList',
			name: 'staffIndexList',
			component: staffIndexList,
			meta: {
				title: 'staffIndexList'
			}
		},
		{
			// 职工管理-职工信息详情
			path: '/moduleIndex/staffManagement/staffInfoDetails',
			name: 'staffInfoDetails',
			component: staffInfoDetails,
			meta: {
				title: 'staffInfoDetails'
			}
		},
		{
			// 职工管理-职工添加
			path: '/moduleIndex/staffManagement/staffAdd',
			name: 'staffAdd',
			component: staffAdd,
			meta: {
				title: 'staffAdd'
			}
		},
		{
			// 学生管理-学生管理列表
			path: '/moduleIndex/studentManagement/studentManagementList',
			name: 'studentManagementList',
			component: studentManagementList,
			meta: {
				title: 'studentManagementList'
			}
		},
		{
			// 学生管理-学生详情
			path: '/moduleIndex/studentManagement/studentDetails',
			name: 'studentDetails',
			component: studentDetails,
			meta: {
				title: 'studentDetails'
			}
		},
		{
			// 学生管理-sunshine Report
			path: '/moduleIndex/studentManagement/sunshineReport',
			name: 'sunshineReport',
			component: sunshineReport,
			meta: {
				title: 'sunshineReport'
			}
		},
		{
			// 家长管理-家长管理列表
			path: '/moduleIndex/parentsManagement/parentsManagementList',
			name: 'parentsManagementList',
			component: parentsManagementList,
			meta: {
				title: 'parentsManagementList'
			}
		},
		{

			// 家长管理-家长详情
			path: '/moduleIndex/parentsManagement/parentsDetails',
			name: 'parentsDetails',
			component: parentsDetails,
			meta: {
				title: 'parentsDetails'
			}
		},
		{
			// 菜单管理-菜品定义
			path: '/moduleIndex/recipe/dishes',
			name: 'dishes',
			component: dishes,
			meta: {
				title: 'dishes'
			}
		},
		{
			// 报名招生-分班统计
			path: '/moduleIndex/enrollAndRecruit/divisionStatistics',
			name: 'divisionStatistics',
			component: divisionStatistics,
			meta: {
				title: 'divisionStatistics'
			}
		},
		{
			// 报名招生-面试题目管理
			path: '/moduleIndex/enrollAndRecruit/interviewQuestions',
			name: 'interviewQuestions',
			component: interviewQuestions,
			meta: {
				title: 'interviewQuestions'
			}
		},
		{
			// 报名招生-汇总页面
			path: '/moduleIndex/enrollAndRecruit/enrollmentManagement',
			name: 'enrollmentManagement',
			component: enrollmentManagement,
			meta: {
				title: 'enrollmentManagement'
			}
		},
		{
			// 报名招生-招生管理-预约参观详情
			path: '/moduleIndex/enrollAndRecruit/enrollmentDetails',
			name: 'enrollmentDetails',
			component: enrollmentDetails,
			meta: {
				title: 'enrollmentDetails'
			}
		},
		{
			// 报名招生-报名表管理
			path: '/moduleIndex/enrollAndRecruit/enrollFormManagement',
			name: 'enrollFormManagement',
			component: enrollFormManagement,
			meta: {
				title: 'enrollFormManagement'
			}
		},
		{
			// 报名招生-报名渠道管理
			path: '/moduleIndex/enrollAndRecruit/channelManagement',
			name: 'channelManagement',
			component: channelManagement,
			meta: {
				title: 'channelManagement'
			}
		},
		{
			// 报名招生-报名渠道管理
			path: '/moduleIndex/enrollAndRecruit/channelGardenManagement',
			name: 'channelGardenManagement',
			component: channelGardenManagement,
			meta: {
				title: 'channelGardenManagement'
			}
		},
		{
			// //报名招生-招生数据漏斗
			path: '/moduleIndex/enrollAndRecruit/enrollmentDataFunnel',
			name: 'enrollmentDataFunnel',
			component: enrollmentDataFunnel,
			meta: {
				title: 'enrollmentDataFunnel'
			}
		},
		{
			// 通知管理- 新建通知
			path: '/moduleIndex/notificationManagement/newNotification',
			name: 'newNotification',
			component: newNotification,
			meta: {
				title: 'newNotification'
			}
		},
		{
			// 通知管理-通知列表展示
			path: '/moduleIndex/notificationManagement/notificationList',
			name: 'notificationList',
			component: notificationList,
			meta: {
				title: 'notificationListDisplay'
			}
		},
		{
			// 
			// 通知管理-通知详情
			path: '/moduleIndex/notificationManagement/notificationDetails',
			name: 'notificationDetails',
			component: notificationDetails,
			meta: {
				title: 'notificationDetails'
			}
		},
		{
			// 
			// 通知管理-学生请假列表
			path: '/moduleIndex/notificationManagement/studentLeaveList',
			name: 'studentLeaveList',
			component: studentLeaveList,
			meta: {
				title: 'studentLeaveList'
			}
		},
		{
			// 通知管理-新建请假
			path: '/moduleIndex/notificationManagement/studentLeaveNew',
			name: 'studentLeaveNew',
			component: studentLeaveNew,
			meta: {
				title: 'studentLeaveNew'
			}
		},
		{
			// 通知管理-请假详情
			path: '/moduleIndex/notificationManagement/studentLeaveDetails',
			name: 'studentLeaveDetails',
			component: studentLeaveDetails,
			meta: {
				title: 'studentLeaveDetails'
			}
		},
		{
			// 通知管理-便条
			path: '/moduleIndex/notificationManagement/chiefMailbox',
			name: 'chiefMailbox',
			component: chiefMailbox,
			meta: {
				title: 'chiefMailbox'
			}
		},
		{
			// 通知管理-意见反馈
			path: '/moduleIndex/notificationManagement/suggest',
			name: 'suggest',
			component: suggest,
			meta: {
				title: 'suggest'
			}
		},
		{
			//活动模版
			path: '/moduleIndex/dailyManagement/activeTemplate',
			name: 'activeTemplate',
			component: activeTemplate,
			meta: {
				title: 'activeTemplate'
			}
		},
		{
			// 日报管理-日报上传
			path: '/moduleIndex/dailyManagement/dailyUpload',
			name: 'dailyUpload',
			component: dailyUpload,
			meta: {
				title: 'dailyUpload'
			},
			children: [{
				path: '/', // 相对路径
				redirect: 'dailyUploadSingle',
			},
			{
				// 单选模式
				path: 'dailyUploadSingle', // 相对路径
				name: 'dailyUploadSingle',
				component: dailyUploadSingle,
				meta: {
					title: 'dailyUploadSingle'
				}
			},
			{
				// 多选模式
				path: 'dailyUploadMultiple', // 相对路径
				name: 'dailyUploadMultiple',
				component: dailyUploadMultiple,
				meta: {
					title: 'dailyUploadMultiple'
				}
			}]
		},
		{
			// 日报管理-日报查询
			path: '/moduleIndex/dailyManagement/dailyQuery',
			name: 'dailyQuery',
			component: dailyQuery,
			meta: {
				title: 'dailyQuery'
			},
			// children:[

			// ]
		},
		{
			path: '/moduleIndex/dailyManagement/dailyDetails',
			name: "dailyDetails",
			component: dailyDetails,
			marta: {
				title: "dailyDetails"
			}
		},
		{
			// 午睡
			path: '/moduleIndex/siesta/index',
			name: 'siestaIndex',
			component: siestaIndex,
			meta: {
				title: 'siesta'
			}
		},
		{
			// 日报管理-日报已读
			path: '/moduleIndex/dailyManagement/dailyRead',
			name: 'dailyRead',
			component: dailyRead,
			meta: {
				title: 'dailyRead'
			},
			// children:[

			// ]
		},
		//缴费管理
		{
			// 收费项目设置
			path: '/moduleIndex/paymentManagement/chargeSetting',
			name: 'chargeSetting',
			component: chargeSetting,
			meta: {
				title: 'chargeSetting'
			}
		},
		{
			// 收费记录
			path: '/moduleIndex/paymentManagement/chargeRecord',
			name: 'chargeRecord',
			component: chargeRecord,
			meta: {
				title: 'chargeRecord'
			}
		},
		{
			// 园所收费项目
			path: '/moduleIndex/paymentManagement/headquartersCharges',
			name: 'headquartersCharges',
			component: headquartersCharges,
			meta: {
				title: 'headquartersCharges'
			}
		},
		{
			// 学生优惠管理
			path: '/moduleIndex/paymentManagement/studentPrivilegeManagement',
			name: 'studentPrivilegeManagement',
			component: studentPrivilegeManagement,
			meta: {
				title: 'studentPrivilegeManagement'
			}
		},
		{
			// 收费账单管理
			path: '/moduleIndex/paymentManagement/chargeBillManagement',
			name: 'chargeBillManagement',
			component: chargeBillManagement,
			meta: {
				title: 'chargeBillManagement'
			}
		},
		{
			// 退款账单管理
			path: '/moduleIndex/paymentManagement/refundBillManagement',
			name: 'refundBillManagement',
			component: refundBillManagement,
			meta: {
				title: 'refundBillManagement'
			}
		},
		{
			// 账单统计
			path: '/moduleIndex/paymentManagement/billCensus',
			name: 'billCensus',
			component: billCensus,
			meta: {
				title: 'billCensus'
			}
		},
		{
			// 当面付二维码
			path: '/moduleIndex/paymentManagement/payQRCode',
			name: 'payQRCode',
			component: payQRCode,
			meta: {
				title: 'payQRCode'
			}
		},
		{
			// 学生收费统计
			path: '/moduleIndex/paymentManagement/studentsChargeCensus',
			name: 'studentsChargeCensus',
			component: studentsChargeCensus,
			meta: {
				title: 'studentsChargeCensus'
			}
		},
		{
			//考勤看板
			path: '/moduleIndex/attendanceManagement/attendanceIndex',
			name: 'attendanceIndex',
			component: attendanceIndex,
			meta: {
				title: 'attendanceIndex'
			}
		},
		{
			//班次配置
			path: '/moduleIndex/attendanceManagement/attendanceConfiguration',
			name: 'attendanceConfiguration',
			component: attendanceConfiguration,
			meta: {
				title: 'attendanceConfiguration'
			}
		},
		{
			//职工每日统计
			path: '/moduleIndex/attendanceManagement/staffDailyStatistics',
			name: 'staffDailyStatistics',
			component: staffDailyStatistics,
			meta: {
				title: 'staffDailyStatistics'
			}
		},
		{
			//学生每日统计
			path: '/moduleIndex/attendanceManagement/studentDailyStatistics',
			name: 'studentDailyStatistics',
			component: studentDailyStatistics,
			meta: {
				title: 'studentDailyStatistics'
			}
		},
		{
			//原始记录 
			path: '/moduleIndex/attendanceManagement/originalCatalog',
			name: 'originalCatalog',
			component: originalCatalog,
			meta: {
				title: 'originalCatalog'
			}
		},
		//      {
		//      	//应用管理 
		//		path: '/moduleIndex/attendanceManagement/applicationManagement',
		//       name: 'applicationManagement',
		//       component: applicationManagement,
		//       meta: {
		//          title: 'applicationManagement'
		//       }
		//      },
		//      {
		//      	//设备管理 
		//		path: '/moduleIndex/attendanceManagement/deviceManagement',
		//       name: 'deviceManagement',
		//       component: deviceManagement,
		//       meta: {
		//          title: 'deviceManagement'
		//       }
		//      },
		{
			//人员管理 
			path: '/moduleIndex/attendanceManagement/personalManagement',
			name: 'personalManagement',
			component: personalManagement,
			meta: {
				title: 'personalManagement'
			}
		},
		{
			//人员管理-编辑页面
			path: '/moduleIndex/attendanceManagement/personalManagementEdit',
			name: 'personalManagementEdit',
			component: personalManagementEdit,
			meta: {
				title: 'personalManagementEdit'
			}
		},
		{
			//人员管理-授权页面
			path: '/moduleIndex/attendanceManagement/personalManagementAuth',
			name: 'personalManagementAuth',
			component: personalManagementAuth,
			meta: {
				title: 'personalManagementAuth'
			}
		},
		{
			// 视频监控
			path: '/moduleIndex/videoMonitoring',
			name: 'videoMonitoring',
			component: videoMonitoring,
			meta: {
				title: 'videoMonitoring'
			}
		},
		{
			// 视频监控-管理视频
			path: '/moduleIndex/managementVideo',
			name: 'managementVideo',
			component: managementVideo,
			meta: {
				title: 'managementVideo'
			}
		},
		{
			// 官网新闻更新 - 公司动态
			path: '/moduleIndex/websiteNewsUpdate/companyDynamic',
			name: 'companyDynamic',
			component: companyDynamic,
			meta: {
				title: 'companyDynamic'
			}
		},
		{
			// 官网新闻更新 - 园所动态
			path: '/moduleIndex/websiteNewsUpdate/gardenDynamic',
			name: 'gardenDynamic',
			component: gardenDynamic,
			meta: {
				title: 'gardenDynamic'
			}
		},
		{
			// 幼儿食谱-每周食谱
			path: '/moduleIndex/recipe/dailyMeal',
			name: 'dailyMeal',
			component: dailyMeal,
			meta: {
				title: 'dailyMeal'
			}
		},
		{
			// 菜单管理-食谱定义
			path: '/moduleIndex/menuManagement/recipesDefine',
			name: 'recipesDefine',
			component: recipesDefine,
			meta: {
				title: 'recipesDefine'
			}
		},
		{
			// 菜单管理-新建食谱
			path: '/moduleIndex/menuManagement/recipesNew',
			name: 'recipesNew',
			component: recipesNew,
			meta: {
				title: 'recipesNew'
			}
		},
		{
			// 菜单管理-食谱详情
			path: '/moduleIndex/menuManagement/recipesDetails',
			name: 'recipesDetails',
			component: recipesDetails,
			meta: {
				title: 'recipesDetails'
			}
		},
		{
			// 菜单管理-菜单定义index
			path: '/moduleIndex/menuManagement/menuDefine',
			name: 'menuDefine',
			component: menuDefine,
			meta: {
				title: 'menuDefine'
			}
		},
		{
			// 菜单管理-新建周套餐
			path: '/moduleIndex/menuManagement/newWeeklySetMeal',
			name: 'newWeeklySetMeal',
			component: newWeeklySetMeal,
			meta: {
				title: 'newWeeklySetMeal'
			}
		},
		{
			// 菜单管理-新建日套餐
			path: '/moduleIndex/menuManagement/newDailyroutine',
			name: 'newDailyroutine',
			component: newDailyroutine,
			meta: {
				title: 'newDailyroutine'
			}
		},
		{
			// 菜单管理-周套餐详情
			path: '/moduleIndex/menuManagement/WeeklySetMealDetails',
			name: 'WeeklySetMealDetails',
			component: WeeklySetMealDetails,
			meta: {
				title: 'WeeklySetMealDetails'
			}
		},
		{
			// 菜单管理-日套餐详情
			path: '/moduleIndex/menuManagement/dailyroutineDetails',
			name: 'dailyroutineDetails',
			component: dailyroutineDetails,
			meta: {
				title: 'dailyroutineDetails'
			}
		},
		{
			// 菜单管理-班级菜单配置
			path: '/moduleIndex/menuManagement/classMunuConfig',
			name: 'classMunuConfig',
			component: classMunuConfig,
			meta: {
				title: 'classMunuConfig'
			}
		},
		{
			// 菜单管理-班级每日菜单
			path: '/moduleIndex/menuManagement/classDailyMenu',
			name: 'classDailyMenu',
			component: classDailyMenu,
			meta: {
				title: 'classDailyMenu'
			}
		},
		{
			// 菜单管理- 配餐统计
			path: '/moduleIndex/menuManagement/foodDistributionStatistics',
			name: 'foodDistributionStatistics',
			component: foodDistributionStatistics,
			meta: {
				title: 'foodDistributionStatistics'
			}
		},
		{
			// 课程管理 -  总部课程管理
			path: '/moduleIndex/courseManagement/headquartersCourseManagement',
			name: 'headquartersCourseManagement',
			component: headquartersCourseManagement,
			meta: {
				title: 'headquartersCourseManagement'
			}
		},
		{
			// 课程管理 -  园所课程管理
			path: '/moduleIndex/courseManagement/gardenCourseManagement',
			name: 'gardenCourseManagement',
			component: gardenCourseManagement,
			meta: {
				title: 'gardenCourseManagement'
			}
		},
		{
			// 课程管理 -  班级课程
			path: '/moduleIndex/courseManagement/classCourse',
			name: 'classCourse',
			component: classCourse,
			meta: {
				title: 'classCourse'
			}
		},
		{
			// 课程管理 -  课程详情
			path: '/moduleIndex/courseManagement/checkCourseDetails',
			name: 'checkCourseDetails',
			component: checkCourseDetails,
			meta: {
				title: 'checkCourseDetails'
			}
		},
		{
			// 共享文档(QA) -  菜单管理
			path: '/moduleIndex/qa/menuManagement',
			name: 'menuManagement',
			component: menuManagement,
			meta: {
				title: 'menuManagement'
			}
		},
		{
			// 共享文档(QA) -  QA部门
			path: '/moduleIndex/shareFileList/fileManagement',
			name: 'fileManagement',
			component: fileManagement,
			meta: {
				title: 'fileManagement'
			}
		},
		{
			// 共享文档(QA) -  文件管理详情
			path: '/moduleIndex/qa/checkFile',
			name: 'checkFile',
			component: checkFile,
			meta: {
				title: 'checkFile'
			}
		},
		{
			// 共享文档(QA) -  分享文件管理
			path: '/moduleIndex/qa/shareFileList',
			name: 'shareFileList',
			component: shareFileList,
			meta: {
				title: 'shareFileList'
			}
		},
		{
			// 共享文档(QA) -  教育课程家长端
			path: '/moduleIndex/qa/eduParentsList',
			name: 'eduParentsList',
			component: eduParentsList,
			meta: {
				title: 'eduParentsList'
			}
		},
		{
			// 共享文档(QA) -  教育课程教师端
			path: '/moduleIndex/qa/eduSchoolList',
			name: 'eduSchoolList',
			component: eduSchoolList,
			meta: {
				title: 'eduSchoolList'
			}
		},
		{
			// 共享文档(QA) -  教育课程家长端
			path: '/moduleIndex/qa/eduContent',
			name: 'eduContent',
			component: eduContent,
			meta: {
				title: 'eduContent'
			}
		},
		{
			// 共享文档(QA) -  培训地图
			path: '/moduleIndex/qa/eduMap',
			name: 'eduMap',
			component: eduMap,
			meta: {
				title: 'eduMap'
			}
		},
		{
			// 共享文档(QA) -  园所培训地图
			path: '/moduleIndex/qa/eduGardenMap',
			name: 'eduGardenMap',
			component: eduGardenMap,
			meta: {
				title: 'eduGardenMap'
			}
		},
		{
			// 共享文档(QA) -  阶段培训地图
			path: '/moduleIndex/qa/eduSecondMap',
			name: 'eduSecondMap',
			component: eduSecondMap,
			meta: {
				title: 'eduSecondMap'
			}
		},
		{
			// 共享文档(QA) -  阶段培训地图
			path: '/moduleIndex/qa/eduMapEmployee',
			name: 'eduMapEmployee',
			component: eduMapEmployee,
			meta: {
				title: 'eduMapEmployee'
			}
		},
		{
			// 共享文档(QA) -  培训地图课程列表
			path: '/moduleIndex/qa/eduMapCourseList',
			name: 'eduMapCourseList',
			component: eduMapCourseList,
			meta: {
				title: 'eduMapCourseList'
			}
		},
		{
			// 权限管理 - 用户
			path: '/moduleIndex/authorityManagement/authorityManagementUser',
			name: 'authorityManagementUser',
			component: authorityManagementUser,
			meta: {
				title: 'user'
			}
		},
		{
			// 权限管理 - 角色
			path: '/moduleIndex/authorityManagement/authorityManagementRole',
			name: 'authorityManagementRole',
			component: authorityManagementRole,
			meta: {
				title: 'role'
			}
		},
		{
			path: '/moduleIndex/systemSet/systemSet',
			name: 'systemSet',
			component: systemSet,
			meta: {
				title: 'systemSet'
			}
		},
		{
			path: '/moduleIndex/systemSet/passwordChange',
			name: 'passwordChange',
			component: passwordSet,
			meta: {
				title: 'passwordChange'
			},
		},
		{ //基本信息
			path: '/moduleIndex/systemSet/information',
			name: ' information',
			component: information,
			meta: {
				title: 'information'
			}
		},
		{
			// 字典设置
			path: '/moduleIndex/dictionaries/index',
			name: 'dictionaries',
			component: dictionaries,
			meta: {
				title: 'dictionaries'
			}
		},
		{
			// 日志管理
			path: '/moduleIndex/Journal/Journal',
			name: 'Journal',
			component: Journal,
			meta: {
				title: 'Journal'
			}
		},
		{
			path: '/moduleIndex/*',
			name: '404',
			component: notFind,
			meta: {
				title: '404'
			}
		}
		]
	},
]
// console.log('first page',sessionStorage.getItem('firstPage'))



console.log(routes)

const vueRouter = new Router({
	// mode:"history",
	routes: routes
})
export default vueRouter


// WEBPACK FOOTER //
// ./src/router/index.js